import { createContext } from "react";

const ApiClientContext = createContext();

export default ApiClientContext;
